const bimg = (id, crop = "entropy", w = 1400) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop&crop=${crop}`;

const A = bimg("photo-1519824145371-296894a0daa9", "top");
const B = bimg("photo-1519823551278-64ac92734fb1", "bottom");
const C = bimg("photo-1745327883508-b6cd32e5dde5", "top");
const D = bimg("photo-1596178060671-7a80dc8059ea", "bottom");

export const POSTURE_POSTS = [
  {
    slug: "massage-for-text-neck",
    title: "Massage for “Text Neck” from Phones and Computers",
    keyword: "massage for text neck",
    category: "Back, Neck, Shoulders & Posture",
    read: "4 min read",
    img: D,
    excerpt:
      "Hours with the head tilted toward a screen multiply the load on the neck several times over. What text neck is and how massage counters it.",
    body: [
      {
        p: [
          "Your head weighs roughly five kilograms — until you tilt it forward. At the angle most of us hold a phone, the effective load on the neck multiplies several times. Do that for hours a day, and the muscles at the base of the skull and down the neck become permanently engaged. That is text neck.",
        ],
      },
      {
        h: "What a session does",
        p: [
          "Work concentrates on the suboccipitals under the skull, the length of the neck, the upper traps and the muscles between the shoulder blades — the whole chain the posture strains. Equally important, the chest is opened: a tight front pulls the head forward and undoes the neck work within days.",
        ],
      },
      {
        h: "The habit that protects it",
        p: [
          "Raise the screen, not the effort. A phone held at eye level and a monitor at eye height remove most of the load; massage removes what has already accumulated. Together they make text neck a chapter, not a biography.",
        ],
      },
    ],
    note:
      "Neck pain with arm numbness, tingling or dizziness needs a physician's assessment before massage.",
  },
  {
    slug: "massage-for-office-workers",
    title: "Massage for Office Workers: Neck, Shoulders and Lower Back",
    keyword: "massage for office workers",
    category: "Back, Neck, Shoulders & Posture",
    read: "4 min read",
    img: A,
    excerpt:
      "The desk-worker trio: a forward head, raised shoulders and a compressed lower back. A session built specifically around the office body.",
    body: [
      {
        p: [
          "Office work is a physical discipline — just one nobody trains for. Eight to ten hours of sitting writes the same pattern into almost every desk worker: the head drifts forward, the shoulders climb and round, the hip flexors shorten, and the lower back is left holding it all together.",
        ],
      },
      {
        h: "A session for the office body",
        p: [
          "Rather than a full-body routine, an office-focused session spends its time where the desk does its damage: neck and suboccipitals, traps and the space between the shoulder blades, then the hips and lower back. The chest gets opened so the shoulders have somewhere to come back to.",
        ],
      },
      {
        h: "How often makes sense",
        p: [
          "For bodies at desks forty-plus hours a week, a session every three to four weeks prevents the slow build-up most people only notice once it hurts. Your benefits plan often covers it — worth checking before the year's end.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-therapy-for-posture",
    title: "Can Massage Therapy Improve Your Posture?",
    keyword: "massage therapy for posture",
    category: "Back, Neck, Shoulders & Posture",
    read: "4 min read",
    img: B,
    excerpt:
      "Posture is not discipline — it is tissue length. How massage changes the structure your posture sits on, and what it cannot do alone.",
    body: [
      {
        p: [
          "Most people try to fix posture by effort: sit up straight, pull the shoulders back. It lasts about ninety seconds, because posture is not held by attention — it is held by tissue. If the chest is short and the upper back is locked, “straight” is a position you cannot actually get into, let alone keep.",
        ],
      },
      {
        h: "What massage changes",
        p: [
          "Massage lengthens what is shortened: it opens the chest and front of the shoulders, releases the locked segments of the upper back, and frees the neck from its forward drift. Clients often describe standing taller after a session without trying — that is tissue length doing what willpower could not.",
        ],
      },
      {
        h: "What it cannot do alone",
        p: [
          "Tissue length is half the equation; the other half is mild strengthening of the muscles that hold the new position. A few simple exercises — your therapist will suggest the relevant ones — turn a post-massage improvement into your default posture.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-for-sitting-all-day",
    title: "Massage for the Body That Sits All Day",
    keyword: "massage for sitting all day",
    category: "Back, Neck, Shoulders & Posture",
    read: "4 min read",
    img: C,
    excerpt:
      "Sitting is not rest for the body — it is a position held for hours. Where the damage accumulates and how a session unwinds it.",
    body: [
      {
        p: [
          "A chair feels like rest, but the body experiences long sitting as work: hip flexors held short, glutes switched off, lower back compressed, shoulders rounded toward the screen. Day after day, these positions stop being positions and become the tissue's new normal.",
        ],
      },
      {
        h: "Where a session unwinds it",
        p: [
          "A sitting-focused session moves in reverse through the pattern: open the hip flexors, wake and release the glutes, decompress the lower back, then free the shoulders and neck. Many clients are surprised that their back pain improves most when the hips are finally addressed.",
        ],
      },
      {
        h: "The thirty-second rule",
        p: [
          "You do not need a standing desk revolution. Standing and moving for thirty seconds every half hour interrupts the accumulation more than any single stretch at the end of the day. Massage clears the backlog; tiny breaks stop it from rebuilding.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-for-stiff-neck",
    title: "Massage for a Stiff Neck: Deep Tissue or Relaxation?",
    keyword: "massage for stiff neck",
    category: "Back, Neck, Shoulders & Posture",
    read: "4 min read",
    img: D,
    excerpt:
      "Woke up unable to turn your head — or stiff for months? The right pressure depends entirely on which one it is.",
    body: [
      {
        p: [
          "“Stiff neck” covers two different situations. The acute one — you woke up and cannot rotate your head — is usually a protective spasm. The chronic one — months of reduced, crunchy movement — is long-held tension in the tissue. They ask for different handling.",
        ],
      },
      {
        h: "The acute spasm: gentle first",
        p: [
          "A fresh, sharp spasm is the neck protecting itself. Strong pressure on day one tends to make it grip harder. The effective approach is surprisingly gentle: warmth, light Swedish strokes, careful positioning — persuading the muscle to stand down rather than forcing it.",
        ],
      },
      {
        h: "The chronic stiffness: deeper, slower",
        p: [
          "Stiffness that has been building for months responds to slow, specific deep tissue work — the levator scapulae, the upper traps, the small muscles at the base of the skull. Range returns layer by layer, usually with noticeable change from the first session.",
          "Not sure which yours is? That is exactly what the first minutes of a session are for.",
        ],
      },
    ],
    note:
      "A stiff neck with fever, severe headache, or after any injury needs medical assessment before massage.",
  },
  {
    slug: "massage-for-shoulder-mobility",
    title: "Massage for Limited Shoulder Mobility",
    keyword: "massage for shoulder mobility",
    category: "Back, Neck, Shoulders & Posture",
    read: "4 min read",
    img: A,
    excerpt:
      "When reaching overhead or behind your back starts shrinking, soft tissue is often the gatekeeper. How massage restores shoulder range.",
    body: [
      {
        p: [
          "Shoulder range disappears gradually — the clasp of a bra gets harder, the top shelf further away, throwing feels tight. Because the joint itself is rarely the first problem: the muscles and fascia around it shorten and start rationing movement long before the joint is involved.",
        ],
      },
      {
        h: "Restoring the range",
        p: [
          "A mobility session maps the restriction first — which direction is limited, what stops it — then works the responsible tissue: the lats and pecs that pull the arm down and forward, the rotator cuff that guides it, the shoulder blade muscles that must move for the arm to rise. Work is combined with gentle guided movement, so the joint practises its range as the tissue releases.",
        ],
      },
      {
        h: "Realistic expectations",
        p: [
          "Soft-tissue restriction responds well and often quickly. If the limitation comes with sharp pain, night pain, or followed an injury, the joint itself may be involved — that version needs a medical opinion first, with massage as a complement afterwards.",
        ],
      },
    ],
    note:
      "Shoulder mobility loss that is progressive over weeks, or paired with significant pain, should be evaluated by a physician — frozen shoulder and joint conditions need diagnosis before bodywork.",
  },
  {
    slug: "massage-for-shoulder-pain",
    title: "Massage for Shoulder Pain: When It Helps and When You Need a Doctor",
    keyword: "massage for shoulder pain",
    category: "Back, Neck, Shoulders & Posture",
    read: "5 min read",
    img: B,
    excerpt:
      "Some shoulder pain is muscular and responds beautifully to massage. Some is not. A clear way to tell which one you are holding.",
    body: [
      {
        p: [
          "The shoulder is the most mobile joint in the body — and the least stable. That makes its pain a mixed bag: often it is overworked soft tissue that massage addresses directly, and sometimes it is the joint or a tendon that needs medicine first. Telling them apart matters.",
        ],
      },
      {
        h: "Pain massage tends to help",
        p: [
          "Dull, diffuse aching across the top of the shoulder and into the neck. Tightness that eases as you warm up. Pain linked to posture, desks, stress or training volume. These patterns live in muscle and fascia — exactly massage's territory.",
        ],
      },
      {
        h: "Pain that needs a doctor first",
        p: [
          "Sharp pain in one specific spot, pain that wakes you at night, weakness (the arm simply will not lift), pain after a fall, or swelling and heat around the joint. These suggest tendon tears, impingement or joint issues — diagnosis first, massage after, often as a very useful part of recovery.",
          "When in doubt, book the doctor. Massage will still be there — and will work better once the picture is clear.",
        ],
      },
    ],
    note:
      "Sudden severe shoulder pain, deformity, or inability to move the arm warrants prompt medical care, not a massage booking.",
  },
  {
    slug: "massage-for-frozen-shoulder",
    title: "Massage for Frozen Shoulder: What to Expect from a Session",
    keyword: "massage for frozen shoulder",
    category: "Back, Neck, Shoulders & Posture",
    read: "5 min read",
    img: C,
    excerpt:
      "Frozen shoulder is a long game measured in months. Where massage genuinely helps within it — and the honesty about what it cannot speed up.",
    body: [
      {
        p: [
          "Frozen shoulder — adhesive capsulitis — is the gradual stiffening of the shoulder joint capsule itself. It typically moves through three phases over one to three years: freezing (painful), frozen (stiff), and thawing (slow return of movement). Massage cannot shorten the condition, but it can meaningfully change how livable each phase is.",
        ],
      },
      {
        h: "What a session actually does",
        p: [
          "The joint capsule is not massage's reach — but everything guarding it is. Sessions release the muscles that clamp around the painful joint (the rotator cuff, the deltoid, the shoulder blade muscles, the neck), which reduces pain, improves sleep, and preserves whatever range is available. Work is gentle; frozen shoulder punishes aggression.",
        ],
      },
      {
        h: "Where it fits in recovery",
        p: [
          "The evidence-supported path is medical guidance plus physiotherapy for the joint, with massage alongside for the muscular fallout. Most clients in the thawing phase find regular sessions help them reclaim range faster and with considerably less discomfort.",
        ],
      },
    ],
    note:
      "Frozen shoulder requires medical diagnosis. Massage is a supportive companion to — never a replacement for — your physician's or physiotherapist's plan.",
  },
  {
    slug: "massage-for-rounded-shoulders",
    title: "Massage for Rounded Shoulders and a Tight Chest",
    keyword: "massage for rounded shoulders",
    category: "Back, Neck, Shoulders & Posture",
    read: "4 min read",
    img: D,
    excerpt:
      "Rounded shoulders are a tug-of-war the front of the body is winning. How opening the chest changes the whole picture.",
    body: [
      {
        p: [
          "Rounded shoulders look like a back problem, but they are usually a front problem. The pectoral muscles shorten from years of keyboards, phones and steering wheels, and simply pull the shoulders forward. The upper back — outmatched — gives up holding them back.",
        ],
      },
      {
        h: "The session, in order",
        p: [
          "Effective work starts at the front: slow release of the pectoralis major and minor, then the front of the shoulder. Only then does the upper back make sense — releasing the overstretched, grumbling muscles between the shoulder blades and re-educating the mid-back to hold its share.",
          "Clients are often surprised how much of their “upper back pain” was actually a tight chest all along.",
        ],
      },
      {
        h: "What holds the result",
        p: [
          "A daily thirty-second doorway chest stretch plus a few upper-back activation exercises protect the change. Without them, the desk re-rounds the shoulders within weeks; with them, each session builds on the last.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-for-si-joint-pain",
    title: "Massage for Sacroiliac (SI) Joint Pain",
    keyword: "massage for SI joint pain",
    category: "Back, Neck, Shoulders & Posture",
    read: "4 min read",
    img: A,
    excerpt:
      "That one-sided ache where the spine meets the pelvis. What the SI joint does, why it complains, and how massage approaches the area.",
    body: [
      {
        p: [
          "The sacroiliac joints sit where the spine meets the pelvis, a few centimetres from the dimples of the lower back. SI pain is typically one-sided: a deep, specific ache when standing up, rolling in bed, or climbing stairs. The joint itself moves only a few degrees — but the muscles around it guard dramatically.",
        ],
      },
      {
        h: "Where massage fits",
        p: [
          "Massage does not adjust the joint — that is not its job. What it does extremely well is release the muscle cast that keeps the area irritated: the glutes on the painful side, the piriformis, the lower back muscles and the hip flexors on the opposite side. As the guarding releases, the joint usually calms considerably.",
        ],
      },
      {
        h: "A pattern worth knowing",
        p: [
          "SI irritation loves asymmetry — crossing the same leg, standing on one hip, driving with a wallet in a back pocket. Part of the session is finding your personal asymmetry and giving it a gentle redesign.",
        ],
      },
    ],
    note:
      "SI-area pain with leg numbness, or pain after a fall or during pregnancy with significant instability, should be assessed medically first.",
  },
  {
    slug: "massage-for-lower-back-spasm",
    title: "Massage for Lower Back Spasms",
    keyword: "massage for lower back spasm",
    category: "Back, Neck, Shoulders & Posture",
    read: "4 min read",
    img: B,
    excerpt:
      "A back spasm is a fire alarm, not a fire. When massage helps it settle, what a session feels like, and how to prevent the next one.",
    body: [
      {
        p: [
          "A lower back spasm arrives without manners: you bend for a shoe and the back locks. A spasm is the nervous system slamming the muscles shut to protect something it considers threatened — the muscular equivalent of a fire alarm. Loud and frightening, but usually guarding fatigue rather than damage.",
        ],
      },
      {
        h: "What a session looks like",
        p: [
          "Timing and gentleness matter. In the first day or two of a sharp spasm, work is light and soothing — the muscle must be talked down, not leaned on. Once the acute phase passes, deeper work addresses why the alarm was so easy to trigger: the chronic tightness in the lower back, hips and glutes underneath.",
        ],
      },
      {
        h: "Fewer alarms",
        p: [
          "Recurrent spasms almost always mean the back is working without help — weak glutes, short hip flexors, long sitting. Regular maintenance sessions plus ten minutes of daily movement keep the alarm threshold high.",
        ],
      },
    ],
    note:
      "A spasm with leg weakness, numbness in the saddle area, or bladder or bowel changes is a medical emergency — seek care immediately.",
  },
  {
    slug: "best-massage-therapist-for-back-pain-edmonton",
    title: "How to Choose a Massage Therapist for Back Pain in Edmonton",
    keyword: "best massage therapist for back pain Edmonton",
    category: "Back, Neck, Shoulders & Posture",
    read: "5 min read",
    img: C,
    excerpt:
      "Credentials, consultation style and the questions worth asking — a short guide to choosing the right RMT for your back in Edmonton.",
    body: [
      {
        p: [
          "Edmonton has no shortage of massage therapists, which makes choosing harder, not easier. When the goal is back pain rather than simple relaxation, a few markers reliably separate a good therapeutic match from a generic appointment.",
        ],
      },
      {
        h: "What to look for",
        p: [
          "A Registered Massage Therapist with verifiable training — in Alberta, look for 2,200-hour program graduates (for example, from colleges like MaKami). A therapist who begins with a real consultation rather than going straight to a routine. Willingness to work within your insurance or direct billing setup, so regular care is actually affordable.",
        ],
      },
      {
        h: "The questions worth asking",
        p: [
          "How will you adapt the session to my back specifically? What should I expect in the days after? How many sessions do you honestly expect this to take? A therapist who answers concretely — and says “I don't know, let's find out” when appropriate — is one who will treat your back as a case, not a timeslot.",
          "At Royal Essence, every session starts with exactly this conversation. The first booking is the best test of fit.",
        ],
      },
    ],
    note: null,
  },
];
